import { createAction, props } from '@ngrx/store';
import { ApplicationException, AutoCompleteResult, HttpException, ServiceException } from '@uzurv/core';
import { IGeoCoords, Location, Sublocation } from '@uzurv/clara';
import { LocationManagerState } from './location-manager.reducer';

export const Reset = createAction('[Location Manager] Reset');

export const Search = createAction('[Location Manager] Search', props<{ searchString: string }>());

export const SearchResultsLoaded = createAction(
  '[Location Manager] Search results loaded',
  props<{ results: Array<AutoCompleteResult> }>()
);

export const LoadSearchResultsFailed = createAction('[Location Manager] Load search results failed', props<{ error: HttpException }>());

export const ClearSearch = createAction('[Location Manager] Clear Search');

export const SearchResultSelected = createAction('[Location Manager] Search result selected', props<{ locationLabel: string }>());

export const LocationLoaded = createAction('[Location Manager] Location loaded', props<{ location: Location }>());

export const LoadLocationFailed = createAction('[Location Manager] Load location failed', props<{ error: HttpException }>());

export const MapLoaded = createAction('[Location Manager] Map loaded');

export const UseOffsetLocation = createAction('[Location Manager] Use offset location', props<{ useOffset: boolean }>());

export const LocationMouseover = createAction('[Location Manager] Location mouse over', props<{ location: Location | Sublocation }>());

export const LocationMouseout = createAction('[Location Manager] Location mouse out', props<{ location: Location | Sublocation }>());

export const LocationSelected = createAction('[Location Manager] Location selected', props<{ location: Location }>());

export const AddNewLocation = createAction('[Location Manager] Add new location');

export const CancelAddNewLocation = createAction('[Location Manager] Cancel adding new location');

export const MoveMap = createAction('[Location Manager] Move map', props<{ coords: IGeoCoords }>());

export const SetNewLocationName = createAction('[Location Manager] Set new location name', props<{ name: string }>());

export const SubmitNewLocation = createAction('[Location Manager] Submit new location');

export const NewLocationInvalid = createAction('[Location Manager] New location invalid', props<{ error: ApplicationException }>());

export const NewLocationAccepted = createAction('[Location Manager] New location accepted', props<{ sublocation: Sublocation }>());

export const SubmitNewLocationFailed = createAction('[Location Manager] Submit new location failed', props<{ error: HttpException }>());

export const DeleteSublocation = createAction('[Location Manager] Delete sublocation', props<{ sublocation: Sublocation }>());

export const DeleteSublocationSuccess = createAction('[Location Manager] Delete sublocation success');

export const DeleteSublocationFailed = createAction('[Location Manager] Delete sublocation failed', props<{ error: HttpException }>());

export const GetUserLocation = createAction('[Location Manager] Get user location');

export const GetUserLocationSuccess = createAction('[Location Manager] Get user location success', props<{ coordinates: IGeoCoords }>());

export const GetUserLocationFailed = createAction('[Location Manager] Get user location failed', props<{ error: ServiceException }>());

export const GeocodeOffsetLocationSuccess = createAction(
  '[Location Manager] Geocode offset location success',
  props<{ location: Location }>()
);

export const GeocodeOffsetLocationFailed = createAction(
  '[Location Manager] Geocode offset location failed',
  props<{ error: ServiceException }>()
);

export const RestoreSnapshot = createAction('[Location Manager] Restore Snapshot', props<{ state: LocationManagerState }>());
